
import React, { useEffect, useRef, useState } from "react";
import sideImage from "./Cloudimages/catren.jpg";
const Landingcaterpage = () => {
    const textRef = useRef(null);
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setAnimate(true);
            },
            { threshold: 0.3 }
        );
        if (textRef.current) observer.observe(textRef.current);
        return () => {
            if (textRef.current) observer.unobserve(textRef.current);
        };
    }, []);

    return (
        <div style={styles.container}>
            {/* Top Center About Heading */}
            <h2 style={styles.sectionHeading}>Caterings and Services</h2>

            <div style={styles.wrapper} className="main-home-about">
                {/* Left Animated Text */}
                <div
                    ref={textRef}
                    style={{
                        ...styles.left,
                        transform: animate ? "translateY(0px)" : "translateY(50px)",
                        opacity: animate ? 1 : 0,
                        transition: "all 0.8s ease",
                    }}
                    className="lading-abouts"
                >
                    <h1 style={styles.heading}>Caterings and Services</h1>
                    <p style={styles.description}>
                        At <strong>Maamaas</strong>, we understand that catering is more than just serving food —
                        it’s about creating memorable experiences. Whether you manage an event catering service,
                        a corporate kitchen, or a wedding food setup, our platform helps you grow your business
                        effortlessly in the digital world.
                        <br /><br />
                        Showcase your menus, highlight your specialties, and receive bookings online without paying
                        heavy commissions or depending on intermediaries. Our tools make it easy to manage inquiries,
                        confirm orders, track deliveries, and communicate directly with your clients — all in one place.
                        <br /><br />

                    </p>
                </div>

                {/* Right Image */}
                <div style={styles.right} className="lading-about">
                    <img src={sideImage} alt="Caterings and Services" style={styles.image} />
                </div>
            </div>
        </div>

    );
};

// ✅ Inline Styles
const styles = {
    container: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px 10px",
    },
    sectionHeading: {
        textAlign: "center",
        fontSize: "28px",
        fontWeight: "bold",
        fontFamily: "'SF Pro', sans-serif",
        color: "#b15cd6",
        marginBottom: "10px",
        marginTop: "0px",
    },
    wrapper: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center", // ✅ Align items vertically
        justifyContent: "space-between",
        gap: "30px", // ✅ Gap between text and image
        width: "100%",
        maxWidth: "64vw",
        backgroundColor: "#f9f9f9",
        padding: "30px 20px",
        borderRadius: "12px",
    },
    left: {
        flex: "1 1 50%",
        // minWidth: "280px",
        marginTop: "10px",
    },
    right: {
        flex: "1 1 45%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // minWidth: "260px",
        marginTop: "10px",
    },
    heading: {
        fontSize: "2rem",
        fontWeight: "bold",
        marginBottom: "15px",
        color: "#222",
    },
    description: {
        fontSize: "1rem",
        lineHeight: "1.6",
        color: "#555",
    },
    image: {
        width: "100%",
        maxWidth: "350px",
        height: "auto",
        borderRadius: "10px",
        objectFit: "cover",
    },
};

export default Landingcaterpage;
